import React, { useState } from "react";
import { useEffect } from "react";
import backgroundImage6 from "../images/user-management.png"; // Your project screenshot
import sharada1 from "../images/sharada1.png";
import echo1 from "../images/echo1.png";
import echo2 from "../images/echo2.png";
import userManagement from "../images/user-management.png";
import quizine1 from "../images/quizine1.png";
import planora1 from "../images/planora1.png";
import { motion } from "framer-motion";

export default function Projects() {
  const [selectedProject, setSelectedProject] = useState(null);
  const [showMore, setShowMore] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 640);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const projects = [
    {
      name: "Sharada NGO Website",
      images: [sharada1],
      description:
        "A modern, responsive website for Sharada NGO, built with React.js and Django. Features include project showcases, donation integration, and a dynamic blog for NGO activities.",
      link: "https://sharada.org.np/",
      techStack: ["React.js", "Django", "HTML", "CSS"],
      features: [
        "Donation system integration",
        "Dynamic blog",
        "Project showcase",
        "Contact and volunteer forms",
      ],
      stats: {
        visitors: "10,000+",
        projects: "15+",
      },
    },
    {
      name: "Echo Innovators Company Website",
      images: [echo1, echo2],
      description:
        "Corporate website for Echo Innovators, built with React.js and Django. Showcases company services, portfolio, and a modern landing page with animations.",
      link: "https://echoinnovators.com.np/",
      techStack: ["React.js", "Django", "HTML", "CSS"],
      features: [
        "Animated landing page",
        "Portfolio section",
        "Service listings",
        "Contact form",
      ],
      stats: {
        clients: "20+",
        projects: "10+",
      },
    },
    {
      name: "User Management App",
      images: [userManagement],
      description:
        "A full-featured user management system with CRUD operations, authentication, and role-based access control. Built with React and Node.js, deployed on Vercel.",
      link: "https://user-management-app-rho-six.vercel.app/",
    },
    {
      name: "Quizine- A QR Based Restaurant Management System",
      images: [quizine1],
      description:
        "A QR-based restaurant management system that streamlines ordering and payment processes. Built with NextJS and Django, deployed on Vercel.",
      link: "https://www.qrrestro.echoinnovators.com.np/",
    },
     {
      name: "Planora- An AI-Powered Event Management Platform",
      images: [planora1],
      description:
        "An AI-powered event management platform that automates scheduling, attendee management, and analytics. Built on NestJS, NextJS and FastAPI(This is not deployed right now.",
      link: "https://www.planora.com.np/",
    },
  ];

  return (
    <div className="max-w-6xl mx-auto px-2 sm:px-4 py-6 sm:py-12">
      <h1 className="text-4xl font-bold mb-12 text-center">
        My Projects
      </h1>

      <div className="grid gap-10">
        {projects.length === 0 ? (
          <p className="text-center text-gray-500">No projects to display.</p>
        ) : (
          <>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 items-start justify-center">
              {(isMobile && !showMore ? projects.slice(0, 2) : projects).map((proj, idx) => (
                <motion.div
                  key={proj.name}
                  className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transform hover:scale-[1.02] transition-all duration-300 cursor-pointer flex flex-col h-auto"
                  onClick={() =>
                    setSelectedProject(
                      proj.name === selectedProject ? null : proj.name
                    )
                  }
                >
                  {/* Image upper part */}
                  <div className="w-full h-48 sm:h-56 flex-shrink-0 flex-grow-0">
                    {proj.images && proj.images.length > 0 ? (
                      <img
                        src={proj.images[0]}
                        alt={proj.name + " screenshot 1"}
                        className="w-full h-full object-contain object-center bg-white"
                      />
                    ) : (
                      <img
                        src={proj.backgroundImage}
                        alt={proj.name}
                        className="w-full h-full object-contain object-center bg-white"
                      />
                    )}
                  </div>
                  {/* Description lower part */}
                  <div className="flex-1 flex flex-col justify-between p-4 overflow-hidden">
                    <h3 className="text-xl sm:text-2xl font-bold text-gray-800 dark:text-white mb-2">
                      {proj.name}
                    </h3>
                    <p className="text-gray-600 dark:text-gray-300 mb-4 overflow-hidden text-ellipsis text-sm sm:text-base" style={{display: '-webkit-box', WebkitLineClamp: 4, WebkitBoxOrient: 'vertical'}}>
                      {proj.description}
                    </p>
                    <motion.a
                      href={proj.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="mt-2 inline-block px-4 sm:px-6 py-2 sm:py-3 bg-gradient-to-r from-green-500 to-blue-500 text-white rounded-full font-semibold hover:opacity-90 transition-opacity duration-300 text-sm sm:text-base"
                      whileHover={{ scale: 1.05 }}
                    >
                      See the website
                    </motion.a>
                  </div>
                </motion.div>
              ))}
            </div>
            {isMobile && !showMore && projects.length > 2 && (
              <div className="flex justify-center mt-4">
                <button
                  className="px-6 py-2 bg-gradient-to-r from-green-500 to-blue-500 text-white rounded-full font-semibold hover:opacity-90 transition-opacity duration-300"
                  onClick={() => setShowMore(true)}
                >
                  Show More
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
